import { analyzeSavings } from 'app/calcs/RetirementSavingsAnalyzer'
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { IRetirementPerson, isValidPerson } from 'app/redux/Profile/model';
import { toCurrency } from 'app/utils';
import { getBrandInfo } from 'config'
import * as moment from 'moment'
import * as React from 'react'

interface IRetirementSummaryContainerState {
  memberAnalysis: any
  spouseAnalysis: any
}

class RetirementSummaryContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, {}> {
  state: IRetirementSummaryContainerState = {
    memberAnalysis: null,
    spouseAnalysis: null
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      const now = moment()
      const profile = appState.Profile.get('info')
      const ratesOfReturn = profile.ratesOfReturn

      const req = {
        member: profile.getHeadOfHousehold(),
        memberInputs: profile.getRetirementForHeadOfHouseHold(),
        spouse: profile.getSpouse(),
        spouseInputs: profile.getRetirementForSpouse(),
        ratesOfReturn
      }
      analyzeSavings(req)
        .then((analysis) => {
          const memberAnalysis = analysis.member
          const spouseAnalysis = analysis.spouse
          this.setState({ memberAnalysis, spouseAnalysis })
        })
    })
  }

  render() {
    if (!this.state.memberAnalysis) { return null }
    const memberName = this.state.memberAnalysis.firstName
    const memberContributions = toCurrency(this.state.memberAnalysis.savings.totalFixedBalances)
    const memberWithdrawal = toCurrency(this.state.memberAnalysis.balanceAsOf(this.state.memberAnalysis.withdrawals.startWithdrawals))
    const memberMonthlyAmount = toCurrency(this.state.memberAnalysis.withdrawals.monthlyWithdrawalAmount)

    let spouseName = ''
    let spouseContributions: string = ''
    let spouseWithdrawal: string
    let spouseMonthlyAmount: string = ''

    const showSpouse: boolean = null !== this.state.spouseAnalysis
    if (showSpouse) {
      spouseName = this.state.spouseAnalysis.firstName
      spouseContributions = toCurrency(this.state.spouseAnalysis.savings.totalFixedBalances)
      spouseWithdrawal = toCurrency(this.state.spouseAnalysis.balanceAsOf(this.state.spouseAnalysis.withdrawals.startWithdrawals))
      spouseMonthlyAmount = toCurrency(this.state.spouseAnalysis.withdrawals.monthlyWithdrawalAmount)
    }

    return (
      <section className="savingsSummary">
        <h1>Summary of Savings</h1>
        <h5 className="lead">Shown below is a summary of the information for your savings.</h5>
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <td></td>
                <td><em>Current Balance</em></td>
                <td><em>Balance at Withdrawal Age</em></td>
                <td><em>Monthly Withdrawal Amount</em></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><a href="#/savings/member/contributions">{memberName}</a></td>
                <td>{memberContributions}</td>
                <td>{memberWithdrawal}</td>
                <td>{memberMonthlyAmount}</td>
              </tr>
              {showSpouse && <tr>
                <td><a href="#/savings/spouse/contributions">{spouseName}</a></td>
                <td>{spouseContributions}</td>
                <td>{spouseWithdrawal}</td>
                <td>{spouseMonthlyAmount}</td>
              </tr>}

            </tbody>
          </table>
        </div>
        {getBrandInfo().markup.retirement.summary.underTable}
        <br />
        <a href="#/dashboard" className="backtodash-link">
          <i className="fa fa-fw fa-arrow-left" />
          &nbsp;Back to Dashboard
        </a>
      </section>
    )
  }
}

const RetirementSummary = () => (
  <RetirementSummaryContainer
    header="Summary" icon="" />
)

export {
  RetirementSummary
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/Summary/index.tsx